var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconoDescargaXml(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 26,
    viewBox: "0 0 20 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.88184 7.96094L4.69531 9.61523L5.50879 7.96094H6.87598L5.48828 10.4287L6.91357 12.9375H5.53271L4.69531 11.2524L3.85791 12.9375H2.47363L3.90234 10.4287L2.51123 7.96094H3.88184ZM8.15479 7.96094H9.13232L10.2432 11.4233L11.354 7.96094H12.3315L10.6396 12.9375H9.84668L8.15479 7.96094ZM7.56006 7.96094H8.57178L8.75977 11.7754V12.9375H7.56006V7.96094ZM11.9146 7.96094H12.9297V12.9375H11.7266V11.7754L11.9146 7.96094ZM17.2368 12.0146V12.9375H14.7212V12.0146H17.2368ZM15.1484 7.96094V12.9375H13.9487V7.96094H15.1484Z",
    fill: "#093C5D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.31026 2.1572H17.4817L17.4817 16.4922H17.4901V20.1875C18.739 20.1835 19.75 19.2892 19.75 18.1865V2.1572C19.75 1.05211 18.7345 0.15625 17.4817 0.15625H2.31026C1.05753 0.15625 0.0419922 1.05211 0.0419922 2.15721V18.1865C0.0419922 19.2916 1.05753 20.1875 2.31026 20.1875H11.027V18.1865L2.31026 18.1865V2.1572Z",
    fill: "#093C5D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4353 20.793H16.3753V17.4596C16.3753 17.093 16.0753 16.793 15.7087 16.793H13.042C12.6753 16.793 12.3753 17.093 12.3753 17.4596V20.793H11.3153C10.722 20.793 10.422 21.513 10.842 21.933L13.902 24.993C14.162 25.253 14.582 25.253 14.842 24.993L17.902 21.933C18.322 21.513 18.0287 20.793 17.4353 20.793Z",
    fill: "#093C5D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconoDescargaXml);
export default __webpack_public_path__ + "static/media/icono_descarga_xml.2041e4fd5711c2aa00b41a4d7a18ebb6.svg";
export { ForwardRef as ReactComponent };